module.exports = __webpack_public_path__ + "img/DownGreyArrow.7ee45bb6.svg";